import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const allergiesSelector = (state: RootState) => state.amwell.activeConsumer.allergies;

export const allergiesDataSelector = createSelector(allergiesSelector, a => a.data);
export const allergiesDataErrorSelector = createSelector(allergiesSelector, a => a.errors.data);
export const allergiesDataLoadingSelector = createSelector(allergiesSelector, a => a.loading.data);

export const allergiesActionLoadingSelector = createSelector(
  allergiesSelector,
  a => a.loading.action
);
export const allergiesActionErrorSelector = createSelector(allergiesSelector, a => a.errors.action);
